var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { PureComponent } from "react";
import styled from "styled-components";
import { get } from "lodash";
import { H4 } from "@irati/ui/src/Headings";
import id from "@irati/utils/id";
import { connect } from "@irati/store";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Card from "@irati/ui/src/Layout/Card";
import { Container, StyledScheduledTransfers, StyledStatementItems, StyledTabs } from "./styled";
var Transactions = /** @class */ (function (_super) {
    __extends(Transactions, _super);
    function Transactions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Transactions.prototype.render = function () {
        var idNamespace = id("balances", this.props);
        var _a = this.props, isPhone = _a.isPhone, formatMessage = _a.formatMessage, selectedTab = _a.selectedTab, onTabChange = _a.onTabChange;
        var Wrapper = isPhone ? styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""]))) : Card;
        return (React.createElement(Container, null,
            React.createElement(Wrapper, null,
                !isPhone && (React.createElement(H4, { small: true },
                    React.createElement(FormattedMessage, { id: "wallet.transactions.heading" }))),
                React.createElement(StyledTabs, { id: id("tabs", idNamespace), onSelect: onTabChange, activeKey: selectedTab, mountOnEnter: true, unmountOnExit: true, fullWidth: isPhone, tabs: [
                        {
                            title: formatMessage({ id: "wallet.transactions.tabs.cleared.title" }),
                            key: "cleared",
                            component: React.createElement(StyledStatementItems, { id: idNamespace })
                        },
                        {
                            title: formatMessage({ id: "wallet.transactions.tabs.pending.title" }),
                            key: "pending",
                            component: React.createElement(StyledScheduledTransfers, { id: idNamespace })
                        },
                        {
                            title: formatMessage({ id: "wallet.transactions.tabs.cancelled.title" }),
                            key: "cancelled",
                            component: React.createElement(StyledScheduledTransfers, { isCancelledTransfers: true, id: idNamespace })
                        }
                    ] }))));
    };
    return Transactions;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return {
        isPhone: get(mq, "lessThan.medium", false)
    };
};
export default injectIntl(connect(mapStateToProps)(Transactions));
var templateObject_1;
